// Announcement

function initCookies() {
    var CookieName = "cookieNotice";
    $('.cookie-notice__close').click(function () {

        //var date = $('#createdDate').val();
        var date2 = new Date();
        console.log(moment(date2).format('YYYY-MM-DD , h:mm:ss a '));
        $(".cookie-notice").addClass('cookie-notice--hide');

        //Need to specify PM 
        Cookies.set(CookieName, { createdDate: moment(date2, 'YYYY-MM-DD ,h:mm:ss A').format('YYYY-MM-DD , h:mm:ss a') }, {
            expires: 365,
        });

    });

};

function deferCookies(method) {
    if (window.jQuery) {
        //console.log('All loaded and ready for cookie notice cookies');
        method();
    }
    else {
        setTimeout(function () { defer(method) }, 50);
    }
}

deferCookies(function () {
    initCookies();
});